import React from 'react'
import Layout from '../Layout'

export default function faq(props) {
    return (
        <Layout props={props}>
            <div className="px-5 py-4">
                {/* <h2>FAQs</h2> */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.terms,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
